import { jsx } from "react/jsx-runtime";
import ShareIcon from "@mui/icons-material/Share";
import { validateTidalLicense } from "../../base/index.js";
function Share(props) {
  return /* @__PURE__ */ jsx(
    ShareIcon,
    {
      "data-testid": "Share",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Share",
      "data-tidal-icon-meta": "fileActions"
    }
  );
}
Share.tidalIconMeta = {
  categories: "fileActions",
  name: "Share"
};
validateTidalLicense();
export {
  Share
};
//# sourceMappingURL=Share.js.map
